import { ApolloQueryResult } from 'apollo-client';

import { BaseDataProvider } from '../../api/BaseDataProvider/BaseDataProvider';
import {
    campaignsAvailableForKeyGoalsQuery,
    campaignsEditDataQuery
} from '../../graphql/queries/grid/campaignsEdit';
import { retargetingConditionsQueryForCampaignsEdit } from '../../graphql/queries/grid/retargeting';
import { FetchCampaignsGoalsAvailableForKeyGoalsInput } from '../../typings/campaignsEdit';
import {
    CampaignsAvailableForKeyGoalsQuery,
    CampaignsEditDataQuery,
    GdCampaignOrderByFieldInput,
    GdRetargetingConditionTypeInput,
    OrderInput,
    RetargetingConditionsQueryForCampaignsEdit
} from '../../typings/graphql-grid';
import { TimeZoneGroup } from '../../typings/timeTargetingEditor';

/* tslint:disable */
// Временный мок данных тайм зон, пока нет API
export const timeZoneGroupsMock = [
    {
        id: '1',
        name: 'Россия',
        timezones: [
            {
                id: '100',
                name: 'Москва'
            },
            {
                id: '101',
                name: 'Калининград (MSK -01:00)'
            },
            {
                id: '102',
                name: 'Барнаул> (MSK +04:00)'
            }
        ]
    },
    {
        id: '2',
        name: 'Страны мира',
        timezones: [
            {
                id: '201',
                name: 'Австрия (GMT +02:00)'
            },
            {
                id: '202',
                name: 'Вьетнам (GMT +07:00)'
            },
            {
                id: '203',
                name: 'Парагвай (GMT -04:00)'
            }
        ]
    }
];
/* tslint:enable */

export class CampaignsDataProvider extends BaseDataProvider {
    public getCampaigns = (
        login: string,
        campaignsIds: Array<string>
    ): Promise<ApolloQueryResult<CampaignsEditDataQuery>> => {
        return this.createQuery<CampaignsEditDataQuery>(
            campaignsEditDataQuery,
            {
                variables: {
                    login: login,
                    campaignInput: {
                        filter: {
                            campaignIdIn: campaignsIds
                        },
                        orderBy: {
                            field: GdCampaignOrderByFieldInput.ID,
                            order: OrderInput.ASC
                        },
                        statRequirements: { preset: 'TODAY' },
                        limitOffset: {
                            offset: 0,
                            limit: 1
                        }
                    },
                    broadMatchGoalsInput: {
                        broadMatchContainers: campaignsIds.map(campaignId => {
                            return {
                                campaignId
                            };
                        })
                    }
                }
            }
        );
    };

    public getRetargetingConditions = (
        login: string
    ): Promise<
        ApolloQueryResult<RetargetingConditionsQueryForCampaignsEdit>
    > => {
        const query = this.createQuery<
            RetargetingConditionsQueryForCampaignsEdit
        >(retargetingConditionsQueryForCampaignsEdit, {
            variables: {
                retargetingConditionsInput: {
                    filter: {
                        retargetingConditionTypeIn: [
                            GdRetargetingConditionTypeInput.METRIKA_GOALS
                        ],
                        interest: false
                    }
                },
                login
            }
        });

        return query;
    };

    public getGoalsAvailableForKeyGoals = (
        login: string,
        availableForKeyGoalsInput: FetchCampaignsGoalsAvailableForKeyGoalsInput[]
    ): Promise<ApolloQueryResult<CampaignsAvailableForKeyGoalsQuery>> => {
        return this.createQuery<CampaignsAvailableForKeyGoalsQuery>(
            campaignsAvailableForKeyGoalsQuery,
            {
                variables: {
                    login: login,
                    availableForKeyGoalsInput: {
                        meaningfulGoalContainers: availableForKeyGoalsInput
                    }
                }
            }
        );
    };

    public getTimeZoneGroups = (login: string): Promise<TimeZoneGroup[]> => {
        return new Promise((resolve, reject) => {
            resolve(timeZoneGroupsMock);
        });
    };
}
